export const ProductsEnum = {
  Economic: 15,
  Express: 44,
  ForNow: 24,
  RPI: 41
}

export default ProductsEnum
